import { FormControl, FormHelperText, FormLabel, Switch } from '@mui/material';

type Props = {
  label?: string;
  value: boolean;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error: string;
  onChange: (value: boolean) => void;
};

const BooleanField = ({ label, value = false, required, disabled, autoFocus, error, onChange }: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <FormControl variant="standard" fullWidth sx={{ height: '37px' }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Switch checked={value} size="small" onChange={handleChange} disabled={disabled} autoFocus={autoFocus} />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default BooleanField;
